import React from 'react';
import { TextField, Typography, Stack } from '@mui/material';
import type { ExecuteCheckpointDef } from '@/types/run-stage.types';

interface CheckpointUserProps {
  checkpoint: ExecuteCheckpointDef;
  value: unknown;
  onChange: (value: string) => void;
  error?: string;
  isReadOnly?: boolean;
}

export const CheckpointUser: React.FC<CheckpointUserProps> = ({
  checkpoint,
  value,
  onChange,
  error,
  isReadOnly,
}) => {
  return (
    <Stack spacing={0.5}>
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {checkpoint.checkpointName}
        {checkpoint.required && <Typography component="span" color="error"> *</Typography>}
      </Typography>
      <TextField
        size="small"
        fullWidth
        placeholder="Search user…"
        value={typeof value === 'string' ? value : ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={isReadOnly}
        error={Boolean(error)}
        helperText={error}
      />
    </Stack>
  );
};
